export default __webpack_public_path__ + "static/hw_ff_servo-870d4a41e4bbf2a2ca9872c10183d275.png";